
    import AppController from "@/controller/AppController";
    import useController from "@/lib/useController";

    export default useController(new AppController);
